import { Note } from '../../ui'
import { warningText, type DryWarning, type WarnCtx } from './groupAdmin'
import { tn } from './nodeSwitch'

/**
 * The warnings of a dry run, first in a confirmation (NG-18 C): one `.sx-note` warn each, a bold
 * first sentence and what it means. They warn and never block (owner V2, V3).
 */
export function WarningNotes({ warnings, ctx, testId = 'dry-warnings' }: { warnings: DryWarning[]; ctx: WarnCtx; testId?: string }) {
  if (!warnings.length) return null
  return (
    <div className="flex flex-col gap-2" data-testid={testId}>
      {warnings.map((w, i) => {
        const x = warningText(w, ctx)
        return (
          <Note key={`${w.code}-${i}`} state="warn" data-testid={`${testId}-${w.code}`}>
            <b className="font-medium text-text">{tn(...x.title)}</b>
            {x.body && <> {tn(...x.body)}</>}
            {x.raw && <> {x.raw}</>}
          </Note>
        )
      })}
    </div>
  )
}
